import * as React from "react";
import { Case, CaseDetailResponse, Activity } from "../../api/classes";
import * as actions from "../../store/cases/actions";
import { connect } from "react-redux";
import { GlobalState } from "../../store";
import { RouteComponentProps } from "react-router-dom";
import {
  Typography,
  Paper,
  Select,
  MenuItem,
  StepIcon,
  List,
  ListSubheader,
  Divider,
  Avatar,
  Tabs,
  Tab,
  Chip,
  Button,
  Tooltip,
  IconButton,
  Card,
} from "@material-ui/core";
import UserChip from "../../components/userChip";
import * as constants from "../../api/constants";
import FolderIcon from "@material-ui/icons/Folder";
import UserSelect from "../../components/userSelect";
import CategorySelect from "../../components/categorySelect";
import * as moment from "moment";
import FolderSelect from "../../components/folderSelect";
import { DubitoSvc } from "../../api";
import CaseActivities from "./detail/activity";
import CaseLinks from "./detail/link";
import CaseEvidences from "./detail/evidence";
import CaseReports from "./detail/reports";
import CaseImages from "./detail/images";
import CaseTimeline from "./detail/timeline";
import CaseTags from "./components/caseTags";
import StatusSelect from "src/components/statusSelect";
import { openSnack } from "src/util/util";
import SetPublishedLinkButton from "./components/setPublishedLinkButton";
import { GetCaseRequest } from "src/api/DubitoAPI";
import NoAnalysisReasonDialog from "src/components/dialogs/noAnalysisReasonDialog";
import Loading from "../../components/loading";
import SetCaseTitleDialog from "src/components/dialogs/setCaseTitleDialog";
import { hasPermissionOf } from "src/auth/auth";
import StarIcon from "@material-ui/icons/Star";
import StarOutline from "@material-ui/icons/StarBorderOutlined";
import EmptyState from "src/components/emptyState";
import ApproveDialog from "src/components/dialogs/approveDialog";
import MoreSettings from "src/components/more";

interface CaseDetailParams {
  id: string;
  tab: string;
}
interface Props extends RouteComponentProps<CaseDetailParams> {
  updateRequired: boolean;
  fetchCases: () => void;
  fetchCase: () => void;
  setCaseUpdateRequired: () => void;
}
interface State {
  detail: CaseDetailResponse;
}
class CaseDetail extends React.Component<Props> {
  defaultState = {
    error: undefined,
    detail: undefined as CaseDetailResponse,
    activeTab: "timeline",
    status: undefined,
    folder: undefined,
    assignee: undefined,
    category_id: undefined,
    published_link: undefined,
    is_published: undefined,
    title: undefined,
    evidenceLinks: [],
    evidenceFiles: [],
    reportLinks: [],
    reportFiles: [],
    no_analysis_reason: undefined,
    no_analysis_description: undefined,
    showNoAnalysisReason: false,
    showEditTitle: false,
    showDeleteCase: false,
  };
  state = { ...this.defaultState };
  componentWillMount() {
    /*  if (!this.state.detail || this.props.updateRequired) {
      this.props.fetchCases();
    } */
    if (this.props.match.params.tab) {
      this.setState({ activeTab: this.props.match.params.tab });
    }
    this.getCaseDetail(parseInt(this.props.match.params.id));
  }
  componentWillReceiveProps(next: Props) {
    if (this.props.match.params.id !== next.match.params.id) {
      this.setState(this.defaultState);
      this.getCaseDetail(parseInt(next.match.params.id));
    }
  }

  getCaseDetail = (case_id) => {
    if (!case_id) {
      case_id = parseInt(this.props.match.params.id);
    }
    DubitoSvc.getCase({ case_id }).then((res) => {
      if (!res.case || res.case.folder === "deleted") {
        this.setState({ error: "This case does not exist" });
        return;
      }
      this.setState({ detail: res });
      this.fetchReportDetails();
      this.fetchEvidenceDetails();
    });
  };
  fetchEvidenceDetails = () => {
    DubitoSvc.getEvidenceAttachments({
      case_id: parseInt(this.props.match.params.id),
    } as GetCaseRequest).then((res) => {
      //console.log(res);
      if (res.files || res.links) {
        this.setState({ evidenceLinks: res.links, evidenceFiles: res.files });
      }
    });
  };
  fetchReportDetails = () => {
    DubitoSvc.getReportAttachments({
      case_id: parseInt(this.props.match.params.id),
      test: 1,
    } as GetCaseRequest).then((res) => {
      //console.log(res);
      if (res.files || res.links) {
        this.setState({ reportLinks: res.links, reportFiles: res.files });
      }
    });
  };
  setFolder = (folder) => {
    this.setState({ folder });
    DubitoSvc.setCaseFolder({ case_id: this.state.detail.case.id, folder })
      .then(() => {
        openSnack("Case Updated!", "success");
        this.props.setCaseUpdateRequired();
      })
      .catch(() => {
        openSnack("Case Update Failed!", "error");
        this.setState({ folder: this.state.detail.case.folder });
      });
  };
  setStatus = (status) => {
    if (status === constants.STATUS_NO_ANALYSIS) {
      this.setState({ showNoAnalysisReason: true });
      return;
    }
    this.setState({ status });
    DubitoSvc.setCaseStatus({ case_id: this.state.detail.case.id, status })
      .then(() => {
        openSnack("Case Updated!", "success");
        this.props.setCaseUpdateRequired();
      })
      .catch(() => {
        openSnack("Case Update Failed!", "error");
        this.setState({ status: this.state.detail.case.status });
      });
  };
  onNoAnalysisReasonChange = (value, description) => {
    //console.log(value);
    this.setState({
      showNoAnalysisReason: false,
      no_analysis_reason: value || "",
      no_analysis_description: description || "",
      status: constants.STATUS_NO_ANALYSIS,
    });
    DubitoSvc.setCaseStatus({
      case_id: this.state.detail.case.id,
      status: constants.STATUS_NO_ANALYSIS,
      no_analysis_reason: value,
      no_analysis_description: description || "",
    })
      .then(() => {
        openSnack("Case Updated!", "success");
        this.props.setCaseUpdateRequired();
      })
      .catch(() => {
        openSnack("Case Update Failed!", "error");
        this.setState({ status: this.state.detail.case.status });
      });
  };
  setAssignee = (assignee) => {
    this.setState({ assignee });
    DubitoSvc.setCaseAssignee({ case_id: this.state.detail.case.id, assignee })
      .then(() => {
        openSnack("Case Updated!", "success");
        this.props.setCaseUpdateRequired();
      })
      .catch(() => {
        openSnack("Case Update Failed!", "error");
        this.setState({ assignee: this.state.detail.case.user_id });
      });
  };
  setTitle = (title) => {
    DubitoSvc.setCaseTitle({ case_id: this.state.detail.case.id, title })
      .then(() => {
        this.setState({
          title: title,
          showEditTitle: false,
        });
        openSnack("Case Updated!", "success");
        this.props.setCaseUpdateRequired();
      })
      .catch(() => {
        openSnack("Case Update Failed!", "error");
        this.setState({
          showEditTitle: false,
        });
      });
  };
  setCategory = (category_id) => {
    this.setState({ category_id });
    DubitoSvc.setCaseCategory({
      case_id: this.state.detail.case.id,
      category_id,
    })
      .then(() => {
        openSnack("Case Updated!", "success");
        this.props.setCaseUpdateRequired();
      })
      .catch(() => {
        openSnack("Case Update Failed!", "error");
        this.setState({ category_id: this.state.detail.case.category_id });
      });
  };
  onPublishedLinkChange = (value) => {
    DubitoSvc.setCasePublishedLink({
      case_id: this.state.detail.case.id,
      published_link: value,
    })
      .then(() => {
        this.setState({
          published_link: value,
          is_published: value.length > 0,
        });
        openSnack("Case Updated!", "success");
        this.props.setCaseUpdateRequired();
      })
      .catch(() => {
        openSnack("Case Update Failed!", "error");
      });
  };
  handleStatusChange = () => {};
  setActiveTab = (e, v) => {
    this.setState({ activeTab: v });
    if (v !== "timeline") {
      this.props.history.replace(
        "/case/" + this.props.match.params.id + "/" + v
      );
    } else {
      this.props.history.replace("/case/" + this.props.match.params.id);
    }
  };
  setStarred = () => {
    const isStarred =
      this.state.detail.tags.indexOf(constants.STARRED_TAG_ID) > -1;
    const deletedTags = [];
    const insertedTags = [];
    if (isStarred) {
      deletedTags.push(constants.STARRED_TAG_ID);
    } else {
      insertedTags.push(constants.STARRED_TAG_ID);
    }
    DubitoSvc.editCaseTags({
      case_id: this.state.detail.case.id,
      deletedTags,
      insertedTags,
    })
      .then(() => {
        this.setState({ edit: false });
        this.getCaseDetail(this.state.detail.case.id);
        openSnack("Case Updated!", "success");
      })
      .catch(() => {
        openSnack("Case Update Failed!", "error");
      });
  };
  deleteCase = () => {
    DubitoSvc.setCaseFolder({
      case_id: this.state.detail.case.id,
      folder: "deleted",
    })
      .then(() => {
        openSnack("Case Deleted!", "success");
        this.props.setCaseUpdateRequired();
        this.props.history.replace("/cases");
      })
      .catch(() => {
        openSnack("Case Update Failed!", "error");
        this.setState({ folder: this.state.detail.case.folder });
      });
  };
  closeDeleteCase = () => {
    this.setState({ showDeleteCase: false });
  };
  render() {
    if (this.state.error) {
      return <EmptyState message="There is no such case" />;
    }
    if (!this.state.detail) {
      return <Loading />;
    }
    const canEdit = hasPermissionOf(constants.Permissions.EDIT_CASES);
    const { activeTab } = this.state;
    return (
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          marginLeft: 24,
          marginRight: 24,
        }}
      >
        <div
          style={{
            width: "100%",
            marginTop: 24,
          }}
        >
          <div style={{ paddingTop: 24, marginLeft: 8 }}>
            <div style={{ display: "flex", flexDirection: "row" }}>
              {this.state.showEditTitle && (
                <SetCaseTitleDialog
                  value={this.state.title || this.state.detail.case.title}
                  open={true}
                  onChange={this.setTitle}
                  onClose={() => this.setState({ showEditTitle: false })}
                />
              )}
              {canEdit ? (
                <div style={{ flex: 1, display: "flex", alignItems: "center" }}>
                  <div
                    onClick={() => {
                      this.setState({ showEditTitle: true });
                    }}
                  >
                    <Tooltip
                      placement="right"
                      title="Click to edit"
                      style={{ alignSelf: "flex-start" }}
                    >
                      <Typography variant="headline" style={{}}>
                        {this.state.title || this.state.detail.case.title}
                      </Typography>
                    </Tooltip>
                  </div>
                  <IconButton
                    onClick={this.setStarred}
                    style={{ marginLeft: 4 }}
                  >
                    {this.state.detail.tags.indexOf(constants.STARRED_TAG_ID) >
                    -1 ? (
                      <StarIcon style={{ color: "orange" }} />
                    ) : (
                      <StarOutline />
                    )}
                  </IconButton>
                </div>
              ) : (
                <Typography variant="headline" style={{ flex: 1 }}>
                  {this.state.title || this.state.detail.case.title}
                </Typography>
              )}
              <StatusSelect
                value={this.state.status || this.state.detail.case.status}
                onSelect={this.setStatus}
                readOnly={!canEdit}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              />

              <MoreSettings
                options={[
                  {
                    label: "Delete",
                    onClick: () => {
                      this.setState({ showDeleteCase: true });
                    },
                  },
                ]}
              />
              {this.state.showDeleteCase && (
                <ApproveDialog
                  open={true}
                  title="Delete Case"
                  description="Are you sure that you want to delete this case?"
                  onApprove={this.deleteCase}
                  onCancel={this.closeDeleteCase}
                />
              )}
            </div>
            <div
              style={{ display: "flex", flexDirection: "row", marginBottom: 8 }}
            >
              <Typography style={{ marginTop: 12, marginLeft: 1 }}>
                {this.state.detail.case.is_published === 1
                  ? "PUBLISHED"
                  : "DRAFT"}
              </Typography>
              <Typography style={{ marginTop: 12, marginLeft: 16 }}>
                Created at{" "}
                {moment(this.state.detail.case.created_at).format("LLLL")}
              </Typography>
              <div style={{ flex: 1 }} />
            </div>
            {(this.state.status || this.state.detail.case.status) ===
              "verified" && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                {(this.state.is_published ||
                  this.state.detail.case.is_published === 1) && (
                  <a
                    target="_blank"
                    href={
                      this.state.published_link ||
                      this.state.detail.case.published_link
                    }
                    style={{ flex: 1 }}
                  >
                    <Typography>
                      {this.state.published_link ||
                        this.state.detail.case.published_link}
                    </Typography>
                  </a>
                )}
                {canEdit && (
                  <SetPublishedLinkButton
                    value={
                      this.state.published_link ||
                      this.state.detail.case.published_link
                    }
                    onChange={this.onPublishedLinkChange}
                  />
                )}
              </div>
            )}
            {(this.state.status || this.state.detail.case.status) ===
              constants.STATUS_NO_ANALYSIS && (
              <Card
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  padding: 16,
                }}
              >
                <div style={{ flex: 1 }}>
                  <Typography style={{ fontWeight: "bolder", flex: 1 }}>
                    <Chip
                      style={{
                        color: "white",
                        backgroundColor: constants.statusColors["no_analysis"],
                        marginRight: 12,
                      }}
                      label="No Analysis"
                    ></Chip>
                    {this.state.no_analysis_reason ||
                      this.state.detail.case.no_analysis_reason}
                  </Typography>
                  <Typography style={{ flex: 1, marginTop: 8 }}>
                    {this.state.no_analysis_description ||
                      this.state.detail.case.no_analysis_description}
                  </Typography>
                </div>
                <Button
                  variant="outlined"
                  style={{}}
                  onClick={() => {
                    this.setState({ showNoAnalysisReason: true });
                  }}
                >
                  Change Reason
                </Button>
              </Card>
            )}
            <NoAnalysisReasonDialog
              open={this.state.showNoAnalysisReason}
              value={
                this.state.no_analysis_reason ||
                this.state.detail.case.no_analysis_reason
              }
              description={
                this.state.no_analysis_description ||
                this.state.detail.case.no_analysis_description
              }
              onClose={() => this.setState({ showNoAnalysisReason: false })}
              onChange={this.onNoAnalysisReasonChange}
            />

            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginTop: 8,
                alignItems: "center",
                flexWrap: "wrap",
              }}
            >
              <FolderSelect
                value={this.state.folder || this.state.detail.case.folder}
                onSelect={this.setFolder}
                readOnly={!canEdit}
              />
              <UserSelect
                style={{ marginRight: 16 }}
                id={this.state.assignee || this.state.detail.case.user_id}
                onSelect={this.setAssignee}
                readOnly={!canEdit}
              />
              <CategorySelect
                noCaption
                id={
                  this.state.category_id || this.state.detail.case.category_id
                }
                onSelect={this.setCategory}
                readOnly={!canEdit}
              />
            </div>
            <CaseTags
              case_id={this.state.detail.case.id}
              selected={this.state.detail && this.state.detail.tags}
              onUpdated={this.getCaseDetail}
              readOnly={!canEdit}
            />
          </div>
          {this.state.detail && (
            <>
              <Tabs
                onChange={this.setActiveTab}
                value={this.state.activeTab}
                indicatorColor="primary"
                textColor="primary"
                scrollable
                scrollButtons="off"
                fullWidth
              >
                <Tab value="timeline" label="Timeline" />
                <Tab
                  value="activity"
                  label={
                    <div>
                      Activity
                      <Chip
                        style={{
                          marginLeft: 4,
                          height: 24,
                          fontSize: 12,
                        }}
                        label={this.state.detail.activities.length}
                      />
                    </div>
                  }
                />
                <Tab
                  value="links"
                  label={
                    <div>
                      Claim Links
                      <Chip
                        style={{
                          marginLeft: 4,
                          height: 24,
                          fontSize: 12,
                        }}
                        label={this.state.detail.links.length}
                      />
                    </div>
                  }
                />
                <Tab
                  value="images"
                  label={
                    <div>
                      Images
                      <Chip
                        style={{
                          marginLeft: 4,
                          height: 24,
                          fontSize: 12,
                        }}
                        label={
                          this.state.detail.files
                            ? this.state.detail.files.length
                            : "0"
                        }
                      />
                    </div>
                  }
                />
                <Tab
                  value="evidences"
                  label={
                    <div>
                      Evidences
                      <Chip
                        style={{
                          marginLeft: 4,
                          height: 24,
                          fontSize: 12,
                        }}
                        label={this.state.detail.evidences.length}
                      />
                    </div>
                  }
                />
                <Tab
                  value="reports"
                  label={
                    <div>
                      Reports
                      <Chip
                        style={{
                          marginLeft: 4,
                          height: 24,
                          fontSize: 12,
                        }}
                        label={this.state.detail.reports.length}
                      />
                    </div>
                  }
                />
              </Tabs>
              {activeTab === "timeline" && (
                /*   <CaseTimeline
                  caseId={this.state.detail.case.id}
                  detail={this.state.detail}
                  evidenceLinks={this.state.evidenceLinks}
                  evidenceFiles={this.state.evidenceFiles}
                  reportLinks={this.state.reportLinks}
                  reportFiles={this.state.reportFiles}
                /> */
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <div style={{ flex: 1 }}>
                    <Paper
                      style={{ padding: 16, marginTop: 12, marginRight: 8 }}
                    >
                      <Typography variant="headline">Images</Typography>
                      <Divider style={{ marginTop: 12, marginBottom: 12 }} />
                      <CaseImages
                        caseId={this.state.detail.case.id}
                        files={this.state.detail.files}
                        onUpdate={this.getCaseDetail}
                      />
                    </Paper>
                    <Paper
                      style={{ padding: 16, marginTop: 12, marginRight: 8 }}
                    >
                      <Typography variant="headline">Claim Links</Typography>
                      <Divider style={{ marginTop: 12, marginBottom: 12 }} />
                      <CaseLinks
                        links={this.state.detail.links}
                        case_id={this.state.detail.case.id}
                        onUpdate={this.getCaseDetail}
                      />
                    </Paper>
                    <Paper
                      style={{ padding: 16, marginTop: 12, marginRight: 8 }}
                    >
                      <Typography variant="headline">Reports</Typography>
                      <Divider style={{ marginTop: 12, marginBottom: 12 }} />
                      <CaseReports
                        caseId={this.state.detail.case.id}
                        reports={this.state.detail.reports}
                        links={this.state.reportLinks}
                        files={this.state.reportFiles}
                      />
                    </Paper>
                  </div>
                  <div style={{ flex: 1 }}>
                    <Paper
                      style={{ padding: 16, marginTop: 12, marginLeft: 8 }}
                    >
                      <Typography variant="headline">Activities</Typography>
                      <Divider style={{ marginTop: 12, marginBottom: 12 }} />
                      <CaseActivities
                        case_id={this.state.detail.case.id}
                        activities={this.state.detail.activities}
                        onUpdate={this.getCaseDetail}
                      />
                    </Paper>
                    <Paper
                      style={{ padding: 16, marginTop: 12, marginLeft: 8 }}
                    >
                      <Typography variant="headline">Evidences</Typography>
                      <Divider style={{ marginTop: 12, marginBottom: 12 }} />
                      <CaseEvidences
                        caseId={this.state.detail.case.id}
                        evidences={this.state.detail.evidences}
                        onUpdate={this.getCaseDetail}
                        links={this.state.evidenceLinks}
                        files={this.state.evidenceFiles}
                      />
                    </Paper>
                  </div>
                </div>
              )}
              {activeTab === "activity" && (
                <CaseActivities
                  case_id={this.state.detail.case.id}
                  activities={this.state.detail.activities}
                  onUpdate={this.getCaseDetail}
                />
              )}
              {activeTab === "links" && (
                <CaseLinks
                  links={this.state.detail.links}
                  case_id={this.state.detail.case.id}
                  onUpdate={this.getCaseDetail}
                />
              )}
              {activeTab === "evidences" && (
                <CaseEvidences
                  caseId={this.state.detail.case.id}
                  evidences={this.state.detail.evidences}
                  onUpdate={this.getCaseDetail}
                  links={this.state.evidenceLinks}
                  files={this.state.evidenceFiles}
                  full
                />
              )}
              {activeTab === "images" && (
                <CaseImages
                  caseId={this.state.detail.case.id}
                  files={this.state.detail.files}
                  onUpdate={this.getCaseDetail}
                />
              )}
              {activeTab === "reports" && (
                <CaseReports
                  caseId={this.state.detail.case.id}
                  reports={this.state.detail.reports}
                  links={this.state.reportLinks}
                  files={this.state.reportFiles}
                  full
                />
              )}
            </>
          )}
        </div>
      </div>
    );
  }
}
export default connect(
  (state: GlobalState, own: any) => ({
    updateRequired: state.cases.casesUpdateRequired,
  }),
  (dispatch) => ({
    fetchCases: (): any => dispatch(actions.fetchCases()),
    setCaseUpdateRequired: () => dispatch(actions.setCaseUpdateRequired()),
  })
)(CaseDetail);



// WEBPACK FOOTER //
// ./src/pages/cases/detail.tsx